import { render, staticRenderFns } from "./model-consumer.vue?vue&type=template&id=a133137e&scoped=true&"
import script from "./model-consumer.vue?vue&type=script&lang=js&"
export * from "./model-consumer.vue?vue&type=script&lang=js&"
import style0 from "./model-consumer.vue?vue&type=style&index=0&id=a133137e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a133137e",
  null
  
)

export default component.exports